module.exports = __webpack_public_path__ + "img/article-icon-109.ea38203c.svg";